import React from 'react'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import Image from '../atoms/Image'
import SbEditable from 'storyblok-react'

const ProductCategoryTeaserBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="product-category-teaser-block">
        <div className="product-category-teaser-block-container">
          <div className="product-category-teaser-block-header">
            <div className="product-category-teaser-block-header-headline">
              <h2>{block.headline}</h2>
            </div>
            <div className="product-category-teaser-block-header-text">
              <p>{block.subheadline}</p>
            </div>
          </div>
          <div className="product-category-teaser-block-content">
            {block.product_category_teaser_content?.length > 0 &&
              block.product_category_teaser_content?.map((item, index) => (
                <Link
                  className="product-category-teaser-block-teaser"
                  link={item.link}
                  target={item.tab_link ? '_blank' : '_self'}
                >
                  <div className="product-category-teaser-block-teaser-image">
                    <Image
                      image={item.image}
                      alt={item.alt}
                      imageWidth="600"
                      imageHeight="600"
                    />
                    <div className="product-category-teaser-block-teaser-content">
                      <h3>{item.headline}</h3>
                      {item.text?.length > 0 && (
                        <p className="product-category-teaser-block-teaser-text">
                          {item.text}
                        </p>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ProductCategoryTeaserBlock
